import { ComponentFactoryResolver, Directive, HostListener, Input, OnDestroy, Output, EventEmitter, ViewContainerRef, AfterViewInit } from '@angular/core';
import { IBaseComponent } from '@base/component/IBaseComponent';
import { FrameworkService } from '@core/framework/framework.service';
import { ScreenService } from '@core/framework/screen.service';
import { AppInjector } from '@core/injector/injector.module';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { NavigatorService } from '@m4u-angular/core/framework/navigator.service';
import { DxDateBoxComponent, DxListComponent, DxNumberBoxComponent, DxSelectBoxComponent, DxTagBoxComponent, DxTextBoxComponent } from 'devextreme-angular';
import { DxiColumnComponent, DxoLookupComponent } from 'devextreme-angular/ui/nested';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { StatusColumnComponent } from '../components/status-column/status-column.component';
import { FieldDetailComponentX } from '../layouts/fieldlayouts/field-detailx/fielddetailx.component';
import { FieldFormComponent } from '../layouts/fieldlayouts/field-form/fieldform.component';
import Validator from "devextreme/ui/validator";
import { Utils } from '@m4u-angular/core/helpers/Utils';
import { formatNumber } from 'devextreme/localization';


@Directive({ selector: 'dx-select-box[configEntitySource]' })
export class M4UConfigEntitySourceDirectiveSelectBox {
    constructor(c: DxSelectBoxComponent) {
        c.displayExpr = "Name";
        c.valueExpr = "EntryID";
    }
}

@Directive({ selector: 'dx-tag-box[configEntitySource]' })
export class M4UConfigEntitySourceDirectiveTagBox {
    constructor(c: DxTagBoxComponent) {
        c.displayExpr = "Name";
        c.valueExpr = "EntryID";
    }
}

@Directive({ selector: 'dxo-lookup[configEntitySource]' })
export class M4UConfigEntitySourceLookupColumn {
    constructor(c: DxoLookupComponent) {
        c.displayExpr = "Name";
        c.valueExpr = "EntryID";
    }
}

@Directive({ selector: '[configMonthYear]' })
export class M4UConfigMonthYearDirective implements OnDestroy {
    private subscribtion: Subscription;
    constructor(c: DxDateBoxComponent) {
        c.type = "date";
        c.displayFormat = 'MM/yyyy';
        c.pickerType = "calendar";

        c.calendarOptions =
        {
            maxZoomLevel: "year",
            minZoomLevel: "century"
        };

        //Disable input textbox since it causes problems
        this.subscribtion = c.onContentReady.subscribe((e) => {
            e.component.option('inputAttr', { disabled: true });
        });
    }

    //Clean up
    ngOnDestroy() {
        this.subscribtion.unsubscribe();
    }
}

@Directive({ selector: '[configYear]' })
export class M4UConfigYearDirective implements OnDestroy {
    private subscribtion: Subscription;
    constructor(c: DxDateBoxComponent) {
        c.type = "date";
        c.displayFormat = 'yyyy';
        c.pickerType = "calendar";

        c.calendarOptions =
        {
            maxZoomLevel: "decade",
            minZoomLevel: "century"
        };

        //Disable input textbox since it causes problems
        this.subscribtion = c.onContentReady.subscribe((e) => {
            e.component.option('inputAttr', { disabled: true });
        });
    }

    //Clean up
    ngOnDestroy() {
        this.subscribtion.unsubscribe();
    }
}

@Directive({ selector: '[configTime]' })
export class M4UConfigTimeDirective {
    constructor(c: DxDateBoxComponent, framework: FrameworkService) {

        var Detector = AppInjector.get(DeviceDetectorService);

        c.type = "time";
        c.displayFormat = framework.CompanyInfo.TimeFormatShort;
        c.pickerType = (Detector.isDesktop() ? "list" : "native");
        c.min = null;
        c.max = null;
    }
}

@Directive({ selector: '[formatSum]' })
export class M4UFormatSumDirective {
    constructor(c: DxNumberBoxComponent, framework: FrameworkService) {
        c.format = framework.CompanyInfo.NumberSum;
        c.inputAttr = { inputmode: 'decimal' };
    }
}

@Directive({ selector: '[formatPrice]' })
export class M4UFormatPriceDirective {
    constructor(c: DxNumberBoxComponent, framework: FrameworkService) {
        c.format = framework.CompanyInfo.NumberPrice;
        c.inputAttr = { inputmode: 'decimal' };
    }
}

@Directive({ selector: '[formatPriceWithCurrency]' })
export class FormatPriceWithCurrencyDirective {

    @Input() dataField: string;
    @Input() isShowZero = false;
    @Input('formatPriceWithCurrency') set currencyField(value: string) {
        this.c.calculateCellValue = (data) => {
            const number = data[this.dataField];
            const currency = data[value];

            if (number === null || number === undefined) { return null; }
            if (!this.isShowZero && number === 0) { return null; }

            let result = formatNumber(number, this.framework.CompanyInfo.NumberSum);

            if (currency) { result = `${result} ${currency}`; }

            return result;
        };
    }

    constructor(private c: DxiColumnComponent, private framework: FrameworkService) { }
}

@Directive({ selector: '[formatQuantity]' })
export class M4UFormatQuantityDirective {
    constructor(c: DxNumberBoxComponent, framework: FrameworkService) {
        c.format = framework.CompanyInfo.NumberQuantity;
        c.inputAttr = { inputmode: 'decimal' };
    }
}

@Directive({ selector: '[formatPercent]' })
export class M4UFormatPercentDirective {
    constructor(c: DxNumberBoxComponent, framework: FrameworkService) {
        c.format = framework.CompanyInfo.NumberPercent + "'%'";
        c.inputAttr = { inputmode: 'decimal' };
    }
}

@Directive({ selector: '[formatRate]' })
export class M4UFormatRateDirective {
    constructor(c: DxNumberBoxComponent, framework: FrameworkService) {
        c.format = framework.CompanyInfo.NumberRate;
        c.inputAttr = { inputmode: 'decimal' };
    }
}

@Directive({ selector: '[formatGeneral]' })
export class M4UFormatGeneralDirective {
    constructor(c: DxNumberBoxComponent, framework: FrameworkService) {
        c.format = framework.CompanyInfo.NumberGeneral;
        c.inputAttr = { inputmode: 'decimal' };
    }
}

@Directive({ selector: 'dx-text-box[multiEmail]' })
export class M4UMultiEmailDirective implements AfterViewInit {
    constructor(private c: DxTextBoxComponent, private A: ServiceBagService) {
    }

    ngAfterViewInit() {
        let oElementInstance = this.c.instance;
        let validatorInstance = Validator.getInstance(oElementInstance.element()) as Validator;
        if (!validatorInstance) validatorInstance = new Validator(oElementInstance.element(), {});
        let rules = validatorInstance.option("validationRules");      

        rules.push({
            type: 'custom',
            ignoreEmptyValue: true,
            message: this.A.ResourcesService.RC('lblMultiEmailError'),
            validationCallback: (e) => {
                if (e.value == null) return true;
                return Utils.IsEmail(e.value, true);
            }
        });

        validatorInstance.option("validationRules", rules);
    }
}

@Directive({ selector: '[formatCurrency]' })
export class M4UFormatCurrencyDirective {
    constructor(private c: DxNumberBoxComponent, private framework: FrameworkService) {
    }

    //Append currency value to the current format
    _Currency: string;
    @Input('formatCurrency') set Currency(value: string) {
        this._Currency = value;
        if (value == undefined) return;
        let format;
        if (this.c.format.toString().startsWith(this.framework.CompanyInfo.NumberGeneral)) format = this.framework.CompanyInfo.NumberGeneral;
        if (this.c.format.toString().startsWith(this.framework.CompanyInfo.NumberPrice)) format = this.framework.CompanyInfo.NumberPrice
        if (this.c.format.toString().startsWith(this.framework.CompanyInfo.NumberSum)) format = this.framework.CompanyInfo.NumberSum;

        if (!format) return;
        this.c.format = format.split(';').reduce((acc: string, a: string) => acc += `${a} ${this._Currency};`, "").slice(0, -1);
    }
    get Currency(): string {
        return this._Currency;
    }
}

@Directive({ selector: "[stop-click-propagation]" })
export class M4UStopClickPropagation {
    @HostListener("click", ["$event"])
    public onClick(event: any): void {
        event.stopPropagation();
    }
}

@Directive({ selector: '[field-empty]' })
export class M4UFieldEmptyDirective {
    @Input() Component: IBaseComponent;
    @Input() IsHideLabel: boolean;

    constructor(f: FieldFormComponent, private screen: ScreenService) {
        f.Component = this.Component;
        f.Name = "Empty";
        f.IsHideLabel = this.IsHideLabel;
        f.IsHide = this.screen.IsMobile();
    }
}

@Directive({ selector: '[fieldx-empty]' })
export class M4UFieldXEmptyDirective extends M4UFieldEmptyDirective {
    constructor(f: FieldDetailComponentX, screen: ScreenService) {
        super(f, screen);
        f.Value = "Empty";
    }
}

@Directive({ selector: 'dxi-column[configBooleanColumn]' })
export class M4UConfigBooleanColumnDirective {
    //@Input() Icon: string;
    //@Input() Color: string;
    @Input() Text: string;
    //@Input() IsFullWidth: boolean;
    @Input() FalseColor: string;
    @Input() UseColumnCaption: boolean = false;

    constructor(column: DxiColumnComponent,
        private viewContainerRef: ViewContainerRef,
        private componentFactoryResolver: ComponentFactoryResolver,
        private A: ServiceBagService) {
        column.cellTemplate = this.cellTemplate;
    }

    cellTemplate = (container, options) => {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(StatusColumnComponent);
        const component = this.viewContainerRef.createComponent(componentFactory);
        //component.instance.Icon = options.value ? this.Icon : '';
        component.instance.Text = this.Text || (this.UseColumnCaption ? options.column.caption : this.A.ResourcesService.RC(options.value ? "genYes" : "genNo"));
        //if (options.value) component.instance.Color = '#0fbe7b';
        component.instance.Color = (options.value ? '#0FBE7B' : (this.FalseColor ? this.FalseColor :undefined)); 
        //component.instance.IsFullWidth = this.IsFullWidth;
        const content = component.instance.getHtmlContent();

        //if (options.value) content.classList.add(this.Color);

        container.appendChild(content);
    }
}

@Directive({ selector: "[list-with-pagination]" })
export class M4UListWithPagination {
    @Input() Page: BasePageComponent<BaseEntity, BaseState>;

    constructor(private list: DxListComponent) { }

    ngOnInit() {
        var listTop = this.list['element'].nativeElement.getBoundingClientRect().top;

        // Calculate grid height fit to the page
        let height = window.innerHeight - listTop;

        // Get page footer height
        const pageFooters = document.querySelectorAll('.page-container m4u-footer');
        const pageFooter = pageFooters[pageFooters.length - 1];
        const pageFooterHeight = pageFooter && pageFooter['offsetParent'] && (pageFooter['offsetParent'].offsetHeight - pageFooter['offsetTop']) || 0;

        // Get layout padding
        const pageContainers = document.getElementsByClassName('page-content-container');
        const currentLayoutPadding = +document.defaultView
            .getComputedStyle(pageContainers[pageContainers.length - 1], '')
            .getPropertyValue('padding-bottom').match(/\d/g).join('');

        // If less than header and one row add window height
        this.list.height = (height < 160 ? height + window.innerHeight : height) - currentLayoutPadding - pageFooterHeight; // Layout padding, page footer

    }

}

@Directive({ selector: '[field-link]' })
export class M4UFieldLinkDirective {
    @Input() NavPath: string;
    @Input() NavParams: any;
    @Input() NavEntryID: number;

    private _disabled: boolean;
    @Input() set Disabled(value: boolean) {
        this._disabled = value;
        if (this._disabled) this.component.elementAttr = { class: 'm4u-link disabled' };
    }

    constructor(private component: DxTextBoxComponent,
        private navigatorService: NavigatorService) {
        this.component.elementAttr = { class: 'm4u-link' };
        this.component.focusStateEnabled = false;
    }

    @HostListener("click", ["$event"])
    public onClick(event: any): void {
        event.stopPropagation();
        if (this._disabled) return;

        if (!this.NavPath.endsWith('/')) this.NavPath = `${this.NavPath}/`;
        const navEntryID = this.NavEntryID || this.component.value;
        const fullPath = `${this.NavPath}${navEntryID}`;

        this.navigatorService.Navigate([fullPath], this.NavParams);
    }
}

@Directive({ selector: 'dxi-column[link-column]' })
export class M4ULinkColumnDirective {
    @Input() Disabled: (cell: any) => boolean;
    @Output() OnClick = new EventEmitter<any>();

    constructor(column: DxiColumnComponent) {
        column.cssClass = `${column.cssClass || ''} link-column`;
        column.cellTemplate = this.cellTemplate;
    }

    cellTemplate = (container, cell) => {
        const disabled = this.Disabled && this.Disabled(cell);
        container.innerHTML = cell.displayValue || '';
        if (disabled) {
            container.classList.add('disabled');
            return;
        }
        
        container.onclick = (event) => {
            event.stopPropagation();
            this.OnClick.emit(cell);
        }
    }
}

